import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const FarmList = lazy(() => import('../../pages/farm/farm/FarmList'));
const FarmCropDetails = lazy(() => import('../../pages/farm/farm/FarmCropDetails'));
const DailyLogs = lazy(() => import('../../pages/farm/daily_logs/DailyLogs'));
const ServiceRequestList = lazy(() => import('../../pages/farm/service_request/ServiceRequestList'));
const FarmExpenseList = lazy(() => import('../../pages/farm/farm_expense/FarmExpenseList'));
const DailyLogList = lazy(() => import('../../pages/farm/daily_logs/DailyLogList'));
const DailylogDetails = lazy(() => import('../../pages/farm/daily_logs/DailylogDetails'));

export const FarmImport = {
    RoutesMap,
    FarmList,
    FarmCropDetails,
    DailyLogs,
    ServiceRequestList,
    FarmExpenseList,
    DailyLogList,
    DailylogDetails,
}